// Same-browser tabs share user_settings changes here; one channel per tab, which never receives its own messages
const CHANNEL_NAME = 'aloware-user-settings'

let channel = null
let removeListener = null

const getChannel = () => {
  if (!channel && typeof BroadcastChannel !== 'undefined') {
    channel = new BroadcastChannel(CHANNEL_NAME)
  }

  return channel
}

// value is cloned: Vue's reactive getters do not survive structured cloning reliably
export const postUserSetting = ({ userId, companyId, name, value }) => {
  const target = getChannel()
  if (!target) {
    return
  }

  target.postMessage({
    user_id: userId,
    company_id: companyId,
    name,
    value: JSON.parse(JSON.stringify(value))
  })
}

// One listener per tab: broadcastInit runs from several components, and a later call replaces the earlier one
export const listenForUserSettings = (handler) => {
  stopListeningForUserSettings()

  const target = getChannel()
  if (!target) {
    return
  }

  const listener = ({ data }) => handler(data)
  target.addEventListener('message', listener)
  removeListener = () => target.removeEventListener('message', listener)
}

export const stopListeningForUserSettings = () => {
  if (removeListener) {
    removeListener()
    removeListener = null
  }
}
